/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
          {{title}}
       </div>
     </button>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{price}}
       </div>
     </div>
   </a>
   {{/products}}
</div>`;



/*
original product markup:
Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
     <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       {{variantinfo}}
     </div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{price}}
       </div>
     </div>
     <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
       {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
     </button>
   </a>
   {{/products}}
</div>`;
*/



function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
    // Get wishlist items
    swat.fetch(function(products) {
        console.log(products); // Log the products to check the response
        var wishlistContentsContainer = document.getElementById("wishlist-items-container");
        var emptyWishlistMessage = '<div class="wishlist-empty" id="empty-wishlist"><h2>Your Wishlist</h2><p>Start adding and organizing your faves<br> so you don\'t lose them.</p><button class="start-adding-button" onclick="closeModal(document.getElementById(\'wishlistModalBox\'))">Start adding</button></div>';
        // Check if there are products in the wishlist
        if (products && products.length === 0) {
            // If no products, show the empty wishlist message
            wishlistContentsContainer.innerHTML = emptyWishlistMessage; // Set the empty message
    document.querySelector('.heart-icon-wrapper').classList.remove('has-items');
        
        } else {
                document.querySelector('.heart-icon-wrapper').classList.add('has-items');
            // Format products for display
            var formattedWishlistedProducts = products.map(function(p) {
                p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
                p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
                p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");

                // Format the product name to show only what's before the '|'
                p.title = getBaseProductName(p.dt); // dt holds the full title

                // Format the price using a simple formatter
                p.price = formatPrice(p.pr); 

                return p;
            });

            // Render the product cards
            var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
                products: formattedWishlistedProducts
            });

            // Insert product cards
            wishlistContentsContainer.innerHTML = productCardsMarkup; 
            attachClickListeners(); // Attach event listeners
        }
    });
}

// Price formatting function (just like the title formatting function)
function formatPrice(price) {
    // Convert to a number and format with commas
    return "$" + Number(price).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getBaseProductName(productName) {
  if (productName.includes('|')) {
    return productName.split('|')[0].trim(); // Get the part before the '|'
  }
  return productName; // Return the full name if '|' is not found
}



function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */




